import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

function formatErr(detail) {
  if (!detail) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, pwd);
      toast.success("Bon retour !");
      if (u.role === "admin") navigate("/admin");
      else if (u.role === "driver") navigate("/driver");
      else navigate("/passenger");
    } catch (e) {
      toast.error(formatErr(e.response?.data?.detail) || "Échec de connexion");
    } finally { setLoading(false); }
  };

  const googleLogin = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:flex bg-black text-white flex-col justify-between p-12 grain">
        <Link to="/" className="font-display text-3xl">TAXI/X</Link>
        <div>
          <p className="font-mono-eyebrow text-[#FFD600]">// Bon retour</p>
          <h2 className="font-display text-5xl mt-3 leading-[0.95]">CONNECTEZ-VOUS.<br/>EN ROUTE.</h2>
        </div>
        <p className="font-mono-eyebrow">/ Authentification sécurisée</p>
      </div>
      <div className="flex items-center justify-center p-6 md:p-12 bg-white">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="login-form">
          <p className="font-mono-eyebrow">// Connexion</p>
          <h1 className="font-display text-4xl mt-2">CONTENT DE VOUS REVOIR</h1>
          <div className="mt-8 space-y-4">
            <div>
              <label className="font-mono-eyebrow">E-mail</label>
              <input data-testid="login-email-input" type="email" required value={email} onChange={e=>setEmail(e.target.value)} className="brut-input mt-2" />
            </div>
            <div>
              <label className="font-mono-eyebrow">Mot de passe</label>
              <input data-testid="login-password-input" type="password" required value={pwd} onChange={e=>setPwd(e.target.value)} className="brut-input mt-2" />
            </div>
            <button data-testid="login-submit-btn" disabled={loading} type="submit" className="brut-btn w-full text-base">
              {loading ? "CONNEXION..." : "SE CONNECTER →"}
            </button>
            <div className="flex items-center gap-3 my-4">
              <div className="brut-divider flex-1" />
              <span className="font-mono-eyebrow">OU</span>
              <div className="brut-divider flex-1" />
            </div>
            <button data-testid="login-google-btn" type="button" onClick={googleLogin} className="brut-btn brut-btn-secondary w-full">
              Continuer avec Google
            </button>
            <p className="text-sm mt-4">Pas de compte ? <Link data-testid="login-to-register-link" to="/register" className="font-bold underline">Inscrivez-vous</Link></p>
          </div>
        </form>
      </div>
    </div>
  );
}
